export default __webpack_public_path__ + "static/45492-bc2c07fa640fb4dece87d6505b414c5b.jpg";